import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {
    Paper,
    Typography,
    Box,
    Button,
    Card,
    CardContent,
    CardActions,
    Modal,
    TextField,
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

import groupsActions from '../../../store/group/actions';
import {selectGroups, selectRootGroup} from '../../../store/group/selectors';
import {IGroup} from '../../../common/group';
import APP_URLs from '../../../consts/url';

type Props = {
    fetchGroups: Function;
    groups: IGroup[];
    rootGroup?: IGroup;
    addGroup: Function;
    deleteGroup: Function;
};
const View = ({fetchGroups, groups, rootGroup, addGroup, deleteGroup}: Props) => {
    const [isAddGroupModalVisible, changeAddGroupModalVisibility] = useState<boolean>(false);
    const [groupToDelete, changeGroupToDelete] = useState<IGroup>();
    const [newGroupName, setNewGroupName] = useState<string>();
    const navigate = useNavigate();
    const handleGroupModalClose = (saveGroup?: boolean) => {
        changeAddGroupModalVisibility(false);
        if (saveGroup && rootGroup) {
            addGroup({name: newGroupName, parentId: rootGroup.id});
        }
        setNewGroupName(undefined);
    }

    const handleGroupDelete = () => {
        deleteGroup(groupToDelete?.id);
        changeGroupToDelete(undefined);
    }

    useEffect(() => {
        fetchGroups()
    }, []);
    return (
        <>
            {groups.map(group => {
                return !group.isRoot && (
                    <Card key={group.id} sx={{p: 3, mb: 1}}>
                        <CardContent
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-start',
                                alignItems: 'center',
                            }}
                        >
                            <Typography
                                component='h2'
                                sx={{
                                    fontWeight: 'bold',
                                    textTransform: 'upperCase',
                                    fontSize: '1.5rem',
                                    color: '#507ebc',
                                    cursor: 'pointer',
                                    marginRight: 'auto',
                                }}
                                onClick={() => navigate(`${APP_URLs.EDIT_GROUP}/${group.id}`)}
                            >
                                {group.name}
                            </Typography>
                            <IconButton color='primary' size='large' onClick={() => changeGroupToDelete(group)}>
                                <DeleteIcon fontSize='large'/>
                            </IconButton>
                        </CardContent>
                    </Card>
                )
            })}
            <IconButton color='primary'
                sx={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '15px',
                }}
                size='large'
                onClick={() => changeAddGroupModalVisibility(true)}
            >
                <AddCircleIcon fontSize='large'/>
            </IconButton>
            <Modal open={isAddGroupModalVisible} onClose={() => handleGroupModalClose()}>
                <Box sx={{
                    backgroundColor: '#fff',
                    width: '280px',
                    p: 4,
                    borderRadius: 1,
                    top: '50%',
                    left: '50%',
                    position: 'absolute',
                    transform: 'translate(-50%, -50%)',
                }}>
                    <TextField
                        type='text'
                        placeholder='Имя группы'
                        onChange={e => setNewGroupName(e.target.value)}
                        fullWidth
                    />
                    <Button
                        variant="contained"
                        sx={{
                            marginX: 'auto',
                            display: 'block',
                            marginTop: 2,
                            width: '100%',
                            p: 2
                        }}
                        onClick={() => handleGroupModalClose(true)}
                    >
                        Создать Группу
                    </Button>
                </Box>
            </Modal>
            <Modal open={Boolean(groupToDelete)} onClose={() => changeGroupToDelete(undefined)}>
                <Box sx={{
                    backgroundColor: '#fff',
                    width: '280px',
                    p: 3,
                    borderRadius: 1,
                    top: '50%',
                    left: '50%',
                    position: 'absolute',
                    transform: 'translate(-50%, -50%)',
                }}>
                    <Typography component='h3'>Вы действительно уверенны что хотите удвлить группу {groupToDelete?.name}?</Typography>
                    <Box sx={{mt: 4, display: 'flex', justifyContent: 'flex-end'}}>
                        <Button variant="contained" onClick={() => handleGroupDelete()}>Да</Button>
                        <Button
                            variant="contained"
                            sx={{backgroundColor: 'error.main', marginLeft: 1}}
                            onClick={() => changeGroupToDelete(undefined)}
                        >
                            Нет
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </>
    )
};

//@ts-expect-error
const mapStateToProps = (state) => ({
    groups: selectGroups(state),
    rootGroup: selectRootGroup(state),
})

//@ts-expect-error
const dispatchProps = (dispatch) => ({
    fetchGroups: bindActionCreators(groupsActions.fetchGroups, dispatch),
    addGroup: bindActionCreators(groupsActions.addGroup, dispatch),
    deleteGroup: bindActionCreators(groupsActions.deleteGroup, dispatch),
})


export default connect(mapStateToProps, dispatchProps)(View);